import { Button, Empty, EmptyDescription, EmptyHeader, EmptyTitle } from "@beweegbaas/ui";
import { Link, useParams, useRouter } from "@tanstack/react-router";
import { useLocaleParams } from "#/modules/util.helpers/route-href";
import { m } from "#/paraglide/messages";

export function NotFoundComponent() {
  const router = useRouter();
  const params = useLocaleParams();
  const { school } = useParams({ strict: false });

  return (
    <main className="flex h-full grow flex-col items-center justify-center gap-8 p-6 text-center">
      <Empty>
        <EmptyHeader>
          <EmptyTitle>{m["common.not_found_title"]()}</EmptyTitle>
          <EmptyDescription>{m["common.not_found_description"]()}</EmptyDescription>
        </EmptyHeader>
      </Empty>
      <div className="flex gap-2">
        <Button variant="secondary" onClick={() => router.history.back()}>
          <IconMaterialSymbolsArrowLeftAlt />
          {m["common.actions.back"]()}
        </Button>
        <Button
          variant="secondary"
          render={
            school ? (
              <Link to="/$locale/{-$schoolyear}/$school" params={{ ...params, school }} />
            ) : (
              <Link to="/$locale/{-$schoolyear}" params={params} />
            )
          }
          nativeButton={false}
        >
          {m["common.actions.home"]()}
        </Button>
      </div>
    </main>
  );
}
